// extracted by mini-css-extract-plugin
module.exports = {"section":"AutoSave24Ani_section__yokcu"};